// config.js
const API_URL = process.env.REACT_APP_API_URL || "https://potal.theeverestnews.com";

export default API_URL;
